// Siparis (Order) API — /api/orders uclari.
import { logoRequest } from './client';
import { ensureSession } from './session';
import { Order, LogoResult } from '../types';

export interface OrderFilter {
  clientCode?: string;
  orderStatus?: number;
  dateBegin?: string;
  dateEnd?: string;
}

function toQuery(f: OrderFilter = {}): Record<string, string | number> {
  const q: Record<string, string | number> = {};
  if (f.clientCode) q.ClientCode = f.clientCode;
  if (f.orderStatus !== undefined) q.OrderStatus = f.orderStatus;
  if (f.dateBegin) q.DateBegin = f.dateBegin;
  if (f.dateEnd) q.DateEnd = f.dateEnd;
  return q;
}

/** GET /api/orders */
export async function getOrders(filter: OrderFilter = {}): Promise<LogoResult<Order[]>> {
  await ensureSession();
  return logoRequest<Order[]>({ url: '/api/orders', method: 'GET', params: toQuery(filter) });
}

/** GET /api/orders/{id} */
export async function getOrder(id: number): Promise<LogoResult<Order>> {
  await ensureSession();
  return logoRequest<Order>({ url: `/api/orders/${id}`, method: 'GET' });
}

/** GET /api/orders/by-number/{orderNumber} */
export async function getOrderByNumber(orderNumber: string): Promise<LogoResult<Order>> {
  await ensureSession();
  return logoRequest<Order>({ url: `/api/orders/by-number/${encodeURIComponent(orderNumber)}`, method: 'GET' });
}

/** POST /api/orders — ekle/guncelle (insert icin id=0). */
export async function saveOrder(order: Order): Promise<LogoResult<Order>> {
  await ensureSession();
  return logoRequest<Order>({ url: '/api/orders', method: 'POST', data: order });
}

/** POST /api/orders/bulk */
export async function saveOrdersBulk(orders: Order[]): Promise<LogoResult<unknown>> {
  await ensureSession();
  return logoRequest<unknown>({ url: '/api/orders/bulk', method: 'POST', data: orders });
}

/** DELETE /api/orders/{id} */
export async function deleteOrder(id: number): Promise<LogoResult<void>> {
  await ensureSession();
  return logoRequest<void>({ url: `/api/orders/${id}`, method: 'DELETE' });
}
